import { FollowUpModal, ModalCallbacksConfig } from 'domain/shared/core/dashboard';
import { DashboardModalConfig } from 'framework/ui/dashboard';
import StaffingRiskIssuesModal from '../components/modals/StaffingRiskIssuesModal';

export const getTeamDashboardModals = (modalCallbacks: ModalCallbacksConfig): DashboardModalConfig[] => [
  {
    key: 'issues',
    title: 'Manage issues',
    component: StaffingRiskIssuesModal,
    maxWidth: 'lg',
    callbacks: modalCallbacks.issues,
  },
  {
    key: 'followUp',
    title: 'Add Follow Up',
    component: FollowUpModal,
    maxWidth: 'md',
    callbacks: modalCallbacks.followUp,
  },
  {
    key: 'changeZone',
    title: 'Change Zone',
    component: StaffingRiskIssuesModal,
    maxWidth: 'lg',
    callbacks: modalCallbacks.changeZone,
  },
];
